
import { defineComponent } from 'vue';
import Spoiler from "../components/Spoiler.vue";
interface IAccorionItem {
    id: number;
    opened: boolean;
    title: string;
    text: string;
}

export default defineComponent({
    components: {
      Spoiler
    },
    data() {
        return {
            values: 1,
            list: [
                {
                    id: 1,
                    opened: false,
                    title: 'Lorem ipsum',
                    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptas laboriosam ipsum consectetur praesentium expedita doloribus debitis tempore mollitia saepe cumque.'
                },
                {
                    id: 2,
                    opened: false,
                    title: 'Hic, fugit',
                    text: 'Hic, fugit. Sed illum, modi, odio veritatis nobis laudantium quod dolores doloremque itaque accusantium neque temporibus expedita velit ab quae.'
                },
                {
                    id: 3,
                    opened: false,
                    title: 'Deleniti laborum',
                    text: 'Deleniti laborum excepturi nobis repellendus et culpa dolorem nulla, similique corporis saepe natus nisi laudantium aliquid ab assumenda, minima aperiam.'
                },
                {
                    id: 4,
                    opened: false,
                    title: 'Optio culpa',
                    text: 'Optio culpa aperiam illo molestiae earum sapiente, placeat, quidem, veniam odit nulla eaque vel aspernatur sed? Dolorum esse accusamus excepturi.'
                },
            ] as IAccorionItem[]
        };
    },
    methods: {
        onClick({id}: IAccorionItem) {
            this.list.forEach((item) => (item.opened = (id === item.id && !item.opened)));
        }
    }
});
